<div class="flex whitespace-nowrap justify-start items-center">
	<ng-container [ngSwitch]="status">
		<span class="text-green" *ngSwitchCase="MATTER_STATUS.ACTIVE"
			><app-icon
				class="mr-1 text-xs"
				[icon]="ICON.DOT"
				[iconStyle]="ICON_STYLE.SOLID"
			></app-icon
			>Active</span
		>
		<span class="text-green" *ngSwitchCase="MATTER_STATUS.CLOSED"
			><app-icon
				class="mr-1 font-bold"
				[icon]="ICON.CHECK"
				[iconStyle]="ICON_STYLE.SOLID"
			></app-icon
			>Closed</span
		>
		<span class="text-grey" *ngSwitchCase="MATTER_STATUS.INACTIVE"
			><app-icon
				class="mr-1 text-xs"
				[icon]="ICON.DOT"
				[iconStyle]="ICON_STYLE.SOLID"
			></app-icon
			>Inactive</span
		>
	</ng-container>
</div>
